import { Skeleton } from '@mui/material';

export default function PlansSkeleton() {
	return (
		<div className="flex min-w-0 flex-auto flex-col">
			<div className="w-full px-4 sm:px-8">
				{/* Billing toggle skeleton */}
				<div className="flex justify-center mb-12">
					<Skeleton variant="rounded" width={164} height={42} sx={{ borderRadius: '12px' }} />
				</div>

				{/* Plan cards skeleton */}
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
					{[1, 2].map((i) => (
						<div
							key={i}
						>
							<Skeleton variant="rounded" width="100%" height={558} sx={{ borderRadius: '16px' }} />
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
